<app-interfix-and-hypothesis-edit
  [showProgressBar]="showProgressBar"
  [isHypothesis]="false"
  [element]="interfix"
  [errorMessageSource]="errorMessageSource"
  (changedElementIdEvent)="getInterfixById($event)"
  (saveElementEvent)="save($event)"
></app-interfix-and-hypothesis-edit>
